// extracted by mini-css-extract-plugin
module.exports = {"breakerInfo":"AccountBreaker_breakerInfo__3cas1"};